export default __webpack_public_path__ + "static/media/summernote.5eb9e4dd.woff";